import { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '../../Nodes/Button'
import TextField from '../../Nodes/TextField'
import { H4, Body1, Body2 } from '../../Nodes/Typography'
import { isValidEmail } from '../../../utilities/email'
import { post } from '../../../utilities/requests'
import { AUTH_URL } from '../../../utilities/constants'

class EmailOptin extends Component {
    state = {
        completed: false,
        success: false,
        validEmail: true,
        email: ''
    }

    handleSubmit = (e) => {
        e && e.preventDefault()

        const { email } = this.state
        const { role } = this.props


        if (!isValidEmail(email)) 
            this.setState({ validEmail: false })
        else {
            post(AUTH_URL + '/account/OptinToEmailSubscription', { email, role }, 'application/json')
                .then(response => {
                    const success = response.status === 200
                    this.setState({ completed: true, success })
                })
                .catch(error => {
                    console.error({ error })
                    this.setState({ completed: true, success: false })
                })
        }
    }

    render() {
        const { completed, success, validEmail } = this.state

        const errorText = 
            completed && !success ? 'There was an error connecting to our servers. Please try again later' :
            !completed && !validEmail ? 'Invalid email entered' :
            ''

        return (
            <div className="email-optin">
                <H4 dangerouslySetInnerHTML={{ __html: this.props.message }} />
                { errorText && <Body2 className="email-optin__error red-text">{errorText}</Body2> }
                { !completed && 
                    (<form onSubmit={this.handleSubmit}>
                        <TextField 
                            type="email" 
                            label="Email" 
                            required 
                            value={this.state.email}
                            onChange={e => this.setState({ email: e.target.value })}
                        /><br />
                        <div className="flex flex--end">
                            <Button raised secondary>Submit</Button>
                        </div>
                    </form>)
                }
                { completed && success && 
                    (<Body1>{this.props.successMessage}</Body1>)}
            </div>
        )
    }
}

EmailOptin.propTypes = {
    message: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired
}

export default EmailOptin